module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/google-pay-payment-card-d262d11cdd7457e47b8d0a3f1e363187.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/google-pay-payment-card.svg
// module id = aVFp
// module chunks = 24